"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A utility function that creates an object of the responsive breakpoints defined in KDS to be accessed through js.
 * @param {Object} breakpoints
 * @returns {BreakpointsObject}
 */
const getBreakpoints = (breakpoints) => {
    const { xsUpper, smUpper, mdUpper, lgUpper, smLower, mdLower, lgLower, xlLower } = breakpoints;
    return {
        xs: { upper: +(xsUpper === null || xsUpper === void 0 ? void 0 : xsUpper.slice(0, -2)), lower: null },
        sm: { upper: +(smUpper === null || smUpper === void 0 ? void 0 : smUpper.slice(0, -2)), lower: +(smLower === null || smLower === void 0 ? void 0 : smLower.slice(0, -2)) },
        md: { upper: +(mdUpper === null || mdUpper === void 0 ? void 0 : mdUpper.slice(0, -2)), lower: +(mdLower === null || mdLower === void 0 ? void 0 : mdLower.slice(0, -2)) },
        lg: { upper: +(lgUpper === null || lgUpper === void 0 ? void 0 : lgUpper.slice(0, -2)), lower: +(lgLower === null || lgLower === void 0 ? void 0 : lgLower.slice(0, -2)) },
        xl: { upper: null, lower: +(xlLower === null || xlLower === void 0 ? void 0 : xlLower.slice(0, -2)) }
    };
};
exports.default = getBreakpoints;
//# sourceMappingURL=getBreakpoints.js.map